import api from './api'
import serviceAPI from './service_api'
import { saveAs } from 'utils/saveAs'
import slugify from 'slugify'

class DocumentDetailsService {
	async downloadDocx({ id, versionId, versionName, documentTitle, companyId }) {
		const slug = slugify(documentTitle + ' ' + versionName)
		const documentName = slug + '.docx'

		return api
			.get(`/documents/${id}/text?version=${versionId}`)
			.then((response) => response.data)
			.then(async (data) => {
				const url = process.env.REACT_APP_HTML_DOCX_URL
				const headers = {
					'Content-Type': 'application/json',
					Accept:
						'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				}
				const payload = JSON.stringify({
					text: data.text,
					companyId: companyId,
				})

				const res = await serviceAPI(process.env.REACT_APP_HTML_DOCX_URL).post(
					url,
					payload,
					{
						headers,
						responseType: 'blob',
					}
				)

				saveAs(res.data, documentName || 'document.docx')

				return {
					id: data.version_id,
					comments: data.comments,
					text: data.text,
					companyId: companyId,
				}
			})
			.catch((error) => {
				console.log(
					'An error occurred in the DocumentDetailsService',
					error.response.data.error
				)
				throw error.response.data.error
			})
	}

	async downloadPdf({ companyId, id, versionId }) {
		const params = {
			company_id: companyId,
			document_id: id,
			version_id: versionId,
		}
		const headers = {
			'Content-Type': 'application/json',
			Accept: 'application/pdf',
		}

		const res = await serviceAPI().get(process.env.REACT_APP_HTML_PDF_URL, {
			headers,
			responseType: 'blob',
			params,
		})

		saveAs(res.data, 'document.pdf')
	}
}

export default new DocumentDetailsService()
